// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2FP0_","colBig":"styles_colBig__ObvA3","colSmall":"styles_colSmall__23Xvd"};